import { AiAssistantProduct, AiAssistantProductVariant } from '../../../store/typings';
import { AiAssistantRecommendedProductsMessage } from '../types';

type RecommendedVariantsList = Array<AiAssistantProductVariant & { product: AiAssistantProduct }>;

const getRecommendedVariantsList = (
    products: AiAssistantRecommendedProductsMessage['products'],
): RecommendedVariantsList =>
    products.flatMap((product) =>
        product.variants
            .filter((variant) => variant.is_recommended)
            .map((variant) => ({ ...variant, product })),
    );

export default getRecommendedVariantsList;
